import React, { useEffect, useState, lazy, Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardTitle, CardContent } from "../../Ui/card.js";
import CardLoading from "../CardLoading.js";
import NetworkNotificationDialog from "./networkGraphDialog.js";
import UseNetworkQuery from "../API/UseNetworkQuery.js";
import { Button } from "../../Ui/button.js";

// Lazy load the NetworkGraph component
const NetworkGraph = lazy(() => import("./networkGraph.js"));

const DisplayNetworkGraph = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [minValue, setMinValue] = useState("0");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("user") === null) {
      navigate("/Footprint");
    }
  }, [navigate]);

  const onSubmit = (newMinValue, newStartDate, newEndDate) => {
    setMinValue(newMinValue);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const address = new URLSearchParams(location.search).get("address");
  let transformedData = { nodes: [], links: [] };

  if (!address) {
    return <div>Please enter an address to view the network graph.</div>;
  }

  const {
    isLoading: networkLoading,
    data: networkData,
    isError: isNetworkError,
  } = UseNetworkQuery(minValue, startDate, endDate);

  const nodeOfFocus = address;

  if (networkData) {
    const nodesMap = new Map();
    let links = [];

    networkData.forEach((item) => {
      nodesMap.set(item.from_address, item.from_image);
      nodesMap.set(item.to_address, item.to_image);
      const valueInEth = item.value / 1e18;
      links.push({
        source: item.from_address,
        target: item.to_address,
        value: valueInEth,
        color:
          item.from_address.toLowerCase() === nodeOfFocus.toLowerCase()
            ? "rgba(255, 0, 0, 0.3)"
            : "rgba(0, 128, 0, 0.5)",
      });
    });

    const nodes = Array.from(nodesMap).map(([id, image]) => {
      return {
        id,
        image,
      };
    });

    transformedData = {
      nodes,
      links,
    };
  }

  return (
    <div className="w-full flex flex-col gap-4 font-roboto p-2 px-4">
      <div className="flex justify-center items-center h-screen">
        <Card className="w-full mx-auto flex flex-col h-full">
          <CardTitle className="px-2">
            <button
              className="my-2 py-2 px-4 text-white rounded bg-primary"
              onClick={() => setIsDialogOpen(true)}
            >
              Filter Network Graph
            </button>
          </CardTitle>
          <CardContent className="flex flex-col justify-center items-center h-full">
            {networkLoading ? (
              <CardLoading className="flex-grow" />
            ) : isNetworkError ? (
              <div className="h-96 font-monda text-5xl flex flex-col gap-4 text-center mt-6 text-red-400">
                error
                <p className="text-gray-700 text-3xl">
                  Cant retrieve values from this wallet address
                </p>
                <p className="text-gray-700 text-3xl">Refresh and try again</p>
                <Button
                  className="w-fit text-white mt-2"
                  onClick={() => navigate("/Footprint")}
                >
                  Return to Footprint
                </Button>
              </div>
            ) : (
              <Suspense fallback={<CardLoading className="flex-grow" />}>
                <NetworkGraph data={transformedData} />
              </Suspense>
            )}
          </CardContent>
        </Card>
      </div>

      <NetworkNotificationDialog
        open={isDialogOpen}
        setOpen={setIsDialogOpen}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default DisplayNetworkGraph;
